import styled from '@emotion/styled';
import H from '@zola/zola-ui/src/typography/Headings';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const StyledHTitle3 = styled(H.Title3)`
  text-align: center;
  margin: auto;
  padding: 56px 0;

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} 0;
    max-width: 400px;
  }

  ${MEDIA_QUERY_V2.TABLET} {
    max-width: 600px;
  }
`;
